import React from 'react';
import css from './Slogan.module.css';

const SloganSection = () => {
  return (
    <div className={css.sloganContainer}>
      <div className={css.sloganContent}>
        <h2 className={css.visuallyHidden}>Quote from Ferdinand Porsche</h2>
        <p className={css.sloganText}>
          'Who told you that you should use the brakes, you should simply drive!'
        </p>
        <div className={css.sloganAuthor}>Ferdinand Porsche</div>
      </div>
    </div>
  );
};

export default SloganSection;
